import React from "react";
import { LegalDocumentModal } from "@/shared/legal/LegalDocumentModal";
import { PRIVACY_POLICY_META, PrivacyPolicyDocument } from "@/shared/legal/PrivacyPolicyDocument";

interface PrivacyPolicyModalProps {
	open: boolean;
	onClose: () => void;
}

export const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({ open, onClose }) => (
	<LegalDocumentModal open={open} onClose={onClose} meta={PRIVACY_POLICY_META}>
		<PrivacyPolicyDocument embedded />
	</LegalDocumentModal>
);
